import { render, staticRenderFns } from "./AddEmployeeLinkWidget.vue?vue&type=template&id=a8958358&scoped=true"
import script from "./AddEmployeeLinkWidget.vue?vue&type=script&lang=ts"
export * from "./AddEmployeeLinkWidget.vue?vue&type=script&lang=ts"
import style0 from "./AddEmployeeLinkWidget.vue?vue&type=style&index=0&id=a8958358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8958358",
  null
  
)

export default component.exports